export const citiesData = {
  'tuymazy': {
    name: 'Туймазы',
    nameRod: 'Туймазах',
    region: 'Республика Башкортостан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Туймазы', 'Туймазинский район', 'Кандры', 'Серафимовский'],
    metaTitle: 'Теплицы в Туймазах - купить теплицу из поликарбоната',
    metaDescription: 'Купить теплицу в Туймазах. Теплицы из поликарбоната от производителя.',
    h1: 'Теплицы из поликарбоната в Туймазах',
    advantages: ['Доставка по Туймазам бесплатно', 'Установка за 1 день', 'Без предоплаты']
  },
  'oktyabrskiy': {
    name: 'Октябрьский',
    nameRod: 'Октябрьском',
    region: 'Республика Башкортостан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Октябрьский', 'Туймазы', 'Бугульма', 'Бавлы'],
    metaTitle: 'Теплица Октябрьский - купить с установкой',
    metaDescription: 'Теплица в Октябрьском от производителя с доставкой.',
    h1: 'Теплицы из поликарбоната в Октябрьском',
    advantages: ['Доставка бесплатно', 'Монтаж за 2-3 часа', 'Оплата после установки']
  },
  'bugulma': {
    name: 'Бугульма',
    nameRod: 'Бугульме',
    region: 'Республика Татарстан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Бугульма', 'Бугульминский район', 'Лениногорск'],
    metaTitle: 'Теплицы в Бугульме - цена от производителя',
    metaDescription: 'Теплица цена Бугульма. Купить теплицу с установкой.',
    h1: 'Теплицы из поликарбоната в Бугульме',
    advantages: ['Доставка по Бугульме бесплатно', 'Установка в удобное время', 'Рассрочка 0%']
  },
  'belebey': {
    name: 'Белебей',
    nameRod: 'Белебее',
    region: 'Республика Башкортостан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Белебей', 'Белебеевский район', 'Приютово'],
    metaTitle: 'Теплицы в Белебее - купить от производителя',
    metaDescription: 'Купить теплицу в Белебее с доставкой и установкой.',
    h1: 'Теплицы из поликарбоната в Белебее',
    advantages: ['Доставка по Белебею бесплатно', 'Установка за 1 день', 'Оплата после монтажа']
  },
  'aznakayevo': {
    name: 'Азнакаево',
    nameRod: 'Азнакаево',
    region: 'Республика Татарстан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Азнакаево', 'Азнакаевский район', 'Бугульма'],
    metaTitle: 'Теплицы в Азнакаево - купить с установкой',
    metaDescription: 'Теплица в Азнакаево от производителя с доставкой.',
    h1: 'Теплицы из поликарбоната в Азнакаево',
    advantages: ['Доставка бесплатно', 'Монтаж в день доставки', 'Гарантия 5 лет']
  }
};

export const getCityBySlug = (slug) => citiesData[slug] || null;
export const getAllCitySlugs = () => Object.keys(citiesData);

// Дополнительные города
export const citiesDataExtra = {
  'bavly': {
    name: 'Бавлы',
    nameRod: 'Бавлах',
    region: 'Республика Татарстан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Бавлы', 'Бавлинский район', 'Октябрьский', 'Бугульма'],
    metaTitle: 'Теплицы в Бавлах - купить теплицу из поликарбоната',
    metaDescription: 'Купить теплицу в Бавлах с доставкой и установкой. Теплицы от производителя.',
    h1: 'Теплицы из поликарбоната в Бавлах',
    advantages: ['Доставка по Бавлам бесплатно', 'Установка за 1 день', 'Гарантия 5 лет']
  },
  'leninogorsk': {
    name: 'Лениногорск',
    nameRod: 'Лениногорске',
    region: 'Республика Татарстан',
    phone: '8-927-348-24-30',
    deliveryZones: ['Лениногорск', 'Лениногорский район', 'Бугульма', 'Азнакаево'],
    metaTitle: 'Теплицы в Лениногорске - купить с установкой',
    metaDescription: 'Теплица в Лениногорске от производителя. Доставка и установка бесплатно.',
    h1: 'Теплицы из поликарбоната в Лениногорске',
    advantages: ['Доставка бесплатно', 'Монтаж в день доставки', 'Оплата после установки']
  }
};

// Объединяем все города
Object.assign(citiesData, citiesDataExtra);

// Еще города
citiesData['bakaly'] = {
  name: 'Бакалы',
  nameRod: 'Бакалах',
  region: 'Республика Башкортостан',
  phone: '8-927-348-24-30',
  deliveryZones: ['Бакалы', 'Бакалинский район', 'Туймазы', 'Белебей'],
  metaTitle: 'Теплицы в Бакалах - купить теплицу из поликарбоната',
  metaDescription: 'Купить теплицу в Бакалах с доставкой и установкой от производителя.',
  h1: 'Теплицы из поликарбоната в Бакалах',
  advantages: ['Доставка по Бакалам бесплатно', 'Установка за 1 день', 'Гарантия 5 лет']
};

citiesData['buzdyak'] = {
  name: 'Буздяк',
  nameRod: 'Буздяке',
  region: 'Республика Башкортостан',
  phone: '8-927-348-24-30',
  deliveryZones: ['Буздяк', 'Буздякский район', 'Туймазы', 'Белебей'],
  metaTitle: 'Теплицы в Буздяке - купить с установкой',
  metaDescription: 'Теплица в Буздяке от производителя. Доставка и установка бесплатно.',
  h1: 'Теплицы из поликарбоната в Буздяке',
  advantages: ['Доставка бесплатно', 'Монтаж в день доставки', 'Оплата после установки']
};
